import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";
import HotelDetail from "../types/HotelDetail";

export default function useHotelDetailsGet (
    hotelId: string,
    options?: CacheQueryOpts
): CacheQueryOutput<HotelDetail> {
    const client = useAPIClient();
    return useCacheQuery<HotelDetail>(
        ["hotel-details", hotelId],
        () => {
            return client.get<any>(hotelId.substring(1));
        },
        options
    );
}